export const pluriaize = (quality, wordFromList, capitalize = false) => {
  const multiplier = Math.abs(parseInt(quality)) % 100
  const tenth = multiplier % 10
  if (multiplier > 10 && multiplier < 20) {
    return wordFromList[2]
  }
  if (tenth > 1 && tenth < 5) {
    return wordFromList[1]
  }
  if (tenth === 1) {
    return wordFromList[0]
  }
  return wordFromList[2]
}

export const pluriaizeOffers = (quality, capitalize = false) => {
  const offerFormList = ['оффер', 'оффера', 'офферов']
  return pluriaize(quality, offerFormList, capitalize)
}

export const pluriaizeLaborer = (quality, capitalize = false) => {
  const offerFormList = ['соискатель', 'соискатели', 'соискателей']
  return pluriaize(quality, offerFormList, capitalize)
}

export const pluriaizeRelays = (quality, capitalize = false) => {
  const offerFormList = ['смена', 'смены', 'смен']
  return pluriaize(quality, offerFormList, capitalize)
}

export const pluriaizeMinutes = (quality, capitalize = false) => {
  const offerFormList = ['минута', 'минуты', 'минут']
  return pluriaize(quality, offerFormList, capitalize)
}

export const pluriaizeHours = (quality, capitalize = false) => {
  const offerFormList = ['час', 'часа', 'часов']
  return pluriaize(quality, offerFormList, capitalize)
}
export const pluriaizeYears = (quality, capitalize = false) => {
  const offerFormList = ['год', 'года', 'лет']
  return pluriaize(quality, offerFormList, capitalize)
}

export const pluriaizeRows = (quality, capitalize = false) => {
  const offerFormList = ['строка', 'строки', 'строк']
  return pluriaize(quality, offerFormList, capitalize)
}
